import React, { Component } from 'react';
import { PnkConnect } from '../../../pnk-react/pnk-miniredux';
import UserListPage from './all-users';
import { GetUsersList } from "../../../models/users";
// import $ from 'jquery';
import AppUtils from '../../../apputils';



class userList extends Component {
    constructor() {
        super()
        this.state = {
            getUsers: true,
            userlist: []
        }
    }

    HandleRouting = (route) => {
        AppUtils.HandlePageClick(this.props.componentprops, route)
    }

    HandleGetUsersListSuccessResponse = (res) => {
        if (res !== false) {
        //    console.log(JSON.stringify(res.data.userlist.rows.length))
            this.setState({
                userlist: res.data.userlist.rows,
                getUsers: false
            })
        }
        else {
            this.setState({
                getUsers: false
            })
        }
    }



    render() {
        return (
            <div>
              { localStorage.getItem('current_user_profile') !== null &&  localStorage.getItem('current_user_profile') === 'admin'?
                <UserListPage {...this.props}
                    HandleRouting={this.HandleRouting} userlist={this.state.userlist}
                />
        :AppUtils.HandlePageClick(this.props.componentprops, 'home')}
                {((this.state.getUsers === true) ? GetUsersList(this.props.PnkStore, this.HandleGetUsersListSuccessResponse) : "")}
            </div>
        )
    }
}

export const UserList = PnkConnect(userList, '');